import { render } from "./News.vue?vue&type=template&id=20e76c1c&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=20e76c1c&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxbxxh\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e76c1c"]])

export default __exports__